<template>
  <div>Упс. Произошла ошибка скачивания файла</div>
</template>

<script>
    export default {
        name: 'DownloadError'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DownloadError.vue?60a5eab3